import React from "react";
import { useTranslation } from "react-i18next";
import { IconButton, Tooltip, Icon, Typography } from "@material-ui/core";

import { DOCS_TAB } from "../../../../util/Constants";
import { useStyles, iconAuto } from "./styles";

export default function DocsButton(props) {
  const { activeTab, handleTabClick, sidebarOpen } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Tooltip title={t("TAB_DOCS")} placement="right">
      <div className={classes.envButton}>
        <IconButton
          id="tab_docs_button"
          className={
            activeTab === DOCS_TAB ? classes.activeTab : classes.normalTab
          }
          onClick={() => {
            handleTabClick(DOCS_TAB, true);
          }}
        >
          <Icon className="fas fa-info-circle" style={iconAuto} />
        </IconButton>
        {sidebarOpen && <Typography>{t("TAB_DOCS")}</Typography>}
      </div>
    </Tooltip>
  );
}
